<app-dialog title="Seleziona punto sulla mappa">
  <div content class="flex flex-column gap-1">
    <div class="relative border-round-sm">
      <div class="absolute top-0 z-5 p-2 w-full flex flex-column gap-1">
        <app-input-text [form]="form" name="search" [autocompleteOptions]="addressSearchResults" autocompleteLabelField="formatted_address" autocompleteValueField="formatted_address" icon="search" placeholder="Cerca indirizzo" clearable></app-input-text>
        <div class="flex justify-content-center gap-1">
          <span matRipple matRippleColor="primary" class="border-round-xl bg-white border-surface px-2 cursor-pointer text-xs text-primary" (click)="getMyLocation()">La mia posizione attuale</span>
          <span matRipple matRippleColor="primary" class="border-round-xl bg-white border-surface px-2 cursor-pointer text-xs text-primary" (click)="setMarkerToMapCenter()">Imposta Marker al centro</span>
          <span *ngIf="markerPosition()" matRipple matRippleColor="primary" class="border-round-xl bg-white border-surface px-2 cursor-pointer text-xs text-primary" (click)="removeMarker()">Rimuovi Marker</span>
        </div>
      </div>
      <google-map
        #myMap="googleMap"
        mapId="get-maps"
        [center]="center()"
        [zoom]="zoom()"
        [options]="options"
        (mapClick)="onMapClick($event)"
        class="w-6"
        width="100%"
        height="300px"
      >
        <map-advanced-marker *ngIf="markerPosition() !== null" [position]="markerPosition()!" />
      </google-map>
    </div>
    <div class="flex justify-content-between gap-2">
      <app-text-field label="Lat" [value]="markerPosition()?.lat ?? '---'" textSize="xs"></app-text-field>
      <app-text-field label="Lng" [value]="markerPosition()?.lng ?? '---'" textSize="xs"></app-text-field>
      <app-text-field label="Alt" [value]="markerPosition()?.altitude ?? '---'" textSize="xs"></app-text-field>
    </div>
  </div>
  <div footer class="w-full">
    <app-button (click)="onSelectClick()" [disabled]="markerPosition() === null" label="Seleziona" raised fullWidth></app-button>
  </div>
</app-dialog>
